import React from 'react';
import styles from './RelatedSwitch.module.scss';
import { Switch } from 'antd';

const RelatedSwitch = ({ checked, onChange, disabled, label, props }) => {
  return (
    <label className={styles.container}>
      {label && <span>{label}</span>}

      <Switch
        checked={checked}
        onChange={onChange}
        disabled={disabled}
        {...props}
      />
    </label>
  );
};

export default RelatedSwitch;
